import { createStyles, keyframes, rem } from "@mantine/core"

export const pulseShrink = keyframes({
    "0": { transform: "scale(1)" },
    "50%": { transform: "scale(0.4)" },
    "100%": { transform: "scale(1)" },
})

export const pulseGrow = keyframes({
    "0": { transform: "scale(1)" },
    "50%": { transform: "scale(1.8)" },
    "100%": { transform: "scale(1)" },
})

export const useStyles = createStyles((theme) => ({
    button: {
        width: "2.5rem",
        minWidth: "2.5rem",
        padding: "0px",
        backgroundColor: theme.colors.violet[7],
        border: "none",
        borderRadius: "2rem",
        transition: "none",

        [theme.fn.largerThan("xs")]: {
            marginRight: rem(12),
        },

        "&:hover": {
            border: "none",

            [theme.fn.largerThan("xs")]: {
                backgroundColor: `${theme.colors.violet[8]} !important`, // because hover state sticks
            },
        },
        "&:focus": {
            boxShadow: "none",
            border: "none",
            [theme.fn.largerThan("xs")]: {
                backgroundColor: `${theme.colors.violet[3]}`,
            },
        },
        "&:active": {
            transform: "none",
        },
    },

    popdownIsOpen: {
        backgroundColor: "#fff",

        "&:hover": {
            border: "none",

            [theme.fn.largerThan("xs")]: {
                backgroundColor: `${theme.colors.violet[1]} !important`, // because hover state sticks
            },
        },
    },

    isOpened: {
        "&:hover": {
            border: "none",

            [theme.fn.largerThan("xs")]: {
                backgroundColor: `${theme.colors.violet[8]} !important`, // because hover state sticks
            },
        },
    },

    active: {
        boxShadow: "none",
        border: "none",
        backgroundColor: `${theme.colors.violet[9]} !important`,
    },

    topBarIcon: {
        color: "white",
    },

    chatIcon: {
        position: "absolute",
        width: "1.25em",
        left: "0.625em",
        height: "1em",
        top: "0.75em",
    },

    bigStarIcon: {
        position: "absolute",
        top: "0.55em",
        left: "1.45em",
        width: "0.5em",
        height: "0.5em",
    },

    smallStarIcon: {
        position: "absolute",
        top: "1em",
        left: "1.2em",
        width: "0.25em",
        height: "0.25em",
    },

    pulseGrow: {
        animation: `${pulseGrow} 1.5s ease-in-out infinite`,
        "@media (prefers-reduced-motion)": {
            animation: "none",
        },
    },

    pulseShrink: {
        animation: `${pulseShrink} 1.5s ease-in-out infinite`,
        "@media (prefers-reduced-motion)": {
            animation: "none",
        },
    },
}))
